import { Link } from "react-router-dom";
import JsonLd from "@/components/feature/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const termsPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "이용약관 | 실전 일본어 연구소",
  "description": "실전 일본어 연구소의 이용약관입니다. 수강 신청, 수업 운영, 수강생 의무, 지식재산권, 환불 규정을 안내합니다.",
  "url": siteUrl ? `${siteUrl}/terms` : "",
  "isPartOf": {
    "@type": "WebSite",
    "name": "실전 일본어 연구소",
    "url": siteUrl
  }
};

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={termsPageSchema} />
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 transition-colors mb-8"
        >
          <i className="ri-arrow-left-line"></i>
          홈으로 돌아가기
        </Link>

        <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
          이용약관
        </h1>
        <p className="text-sm text-foreground-600 mb-10">
          시행일: 2026년 7월 31일
        </p>

        <div className="space-y-10 text-foreground-700 leading-relaxed">
          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              제1조 (목적)
            </h2>
            <p>
              본 약관은 실전 일본어 연구소(이하 "연구소")가 제공하는 온라인 일본어 강의 서비스의 이용과 관련한 권리, 의무 및 운영 기준을 정함을 목적으로 합니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              제2조 (수강 신청 및 계약)
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>수강 신청과 수강료 납부가 완료되고,  연구소가 수강 확정 안내를 발송한 시점에 수강 계약이 성립됩니다.</li>
              <li>연구소는 운영상 필요한 경우 모집을 조기 마감하거나 개강 일정을 변경할 수 있습니다.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              제3조 (수업 운영)
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>수업은 사전에 안내된 일정에 따라 온라인으로 진행됩니다.</li>
              <li>불가피한 사정으로 일정이 변경되는 경우 사전에 안내하며 가능한 보강수업을 제공합니다.</li>
              <li>결석 시 별도의 보강수업은 제공되지 않으며, 가능한 경우 녹화본을 제공합니다.</li>
              <li>녹화본은 가능한 한 수업 후 24시간 이내 제공하며, 제공일로부터 10일간 시청 가능합니다.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              제4조 (수강생의 의무)
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>다른 수강생의 학습을 방해하는 행위를 하지 않습니다.</li>
              <li>Zoom 링크, 녹화본 및 수업자료를 무단 공유하거나 배포하지 않습니다.</li>
              <li>타인의 개인정보를 무단 공유하거나 상업적 홍보 행위를 하지 않습니다.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              제5조 (지식재산권)
            </h2>
            <p className="mb-2">
              강의자료, 교재, PDF, 숙제, 단어자료, 녹화본 등 모든 교육 콘텐츠의 저작권은 연구소에 있습니다.
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>연구소의 사전 동의 없이 복제, 배포, 판매 또는 수정 후 재배포할 수 없습니다.</li>
              <li>강의 자료 및 녹화본을 생성형 AI의 학습, 재생산, 재배포 또는 상업적 목적으로 활용하는 행위를 금지합니다. 다만 개인 학습을 위한 제한적인 AI 활용은 허용하나, 자료의 대량 입력이나 상업적 이용은 금지합니다.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              제6조 (환불)
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>개강 전 수강 취소 시 수강료 전액을 환불합니다.</li>
              <li>개강 후에는 진행된 회차의 수강료를 공제한 후 남은 금액을 환불합니다. 환불금 = 납부한 수강료 − (진행된 회차 × 회당 수강료)</li>
              <li>정상적으로 진행된 수업은 출석 여부와 관계없이 진행된 회차로 계산됩니다.</li>
              <li>환불은 홈페이지에 안내된 연락처를 통해 신청할 수 있으며, 신청일을 기준으로 환불 금액이 산정됩니다.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              제7조 (면책)
            </h2>
            <p>
              연구소는 천재지변, 서비스 장애 또는 이용자의 인터넷 환경·기기 문제 등 연구소의 고의 또는 중대한 과실이 없는 사유로 발생한 손해에 대하여 책임을 부담하지 않습니다.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mb-3">
              제8조 (문의)
            </h2>
            <p>
              서비스 관련 문의는 홈페이지에 기재된 공식 연락처를 통해 가능합니다.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}